<template>
  <div class="app-shell">
    <router-view v-slot="{ Component, route }">
      <transition name="route-signal" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
    <div class="background" aria-hidden="true"></div>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  html {
    scroll-behavior: smooth;
  }

  html,
  body,
  #app {
    font-family: var(--sans);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--text-color);
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100vh;
  }

  body {
    background-color: var(--background-color-dark);
    overflow-x: hidden;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  a {
    color: inherit;
  }

  button,
  input,
  textarea,
  select {
    font: inherit;
  }

  .app-shell {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
  }

  .background {
    position: fixed;
    inset: 0;
    background: var(--paper);
    z-index: -2;
  }

  :focus-visible {
    outline: 2px solid #526d30;
    outline-offset: 4px;
  }

  .route-signal-enter-active,
  .route-signal-leave-active {
    transition: opacity .28s ease, transform .28s ease, filter .28s ease;
  }

  .route-signal-enter-from,
  .route-signal-leave-to {
    filter: saturate(.7);
    opacity: 0;
    transform: translateY(.6rem);
  }

  ::selection {
    background-color: var(--green);
    color: var(--ink);
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: var(--background-color-dark);
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--border-color-light);
    border: 2px solid var(--background-color-dark);
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--secondary-color-dark);
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: .01ms !important;
      animation-iteration-count: 1 !important;
      scroll-behavior: auto !important;
      transition-duration: .01ms !important;
    }
  }
</style>
